import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { NeedaConfig } from "src/app/inventory/supplier/needa-config";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { FrCriteria } from "src/app/util/search/criteria/fr-criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";
import { SupplierSearchCriteriaComponent } from "../../order/search/criteria/supplier-search-criteria.component";
import { Invoice } from "../invoice";
import { InvoiceSearchResult } from "../invoice-search-result";
import { InvoiceService } from "../invoice-service";

@Component({
  templateUrl: './invoice-search.component.html'
})
export class InvoiceSearchComponent extends SearchComponent<InvoiceSearchResult> {
  public query = "";
  public needaConfig!: NeedaConfig;
  public invoice!: Invoice;
  public purchaseOrders!: string[];

  @ViewChild(SupplierSearchCriteriaComponent)
  supplierCriteria!: SupplierSearchCriteriaComponent;

  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(new Map<string, Criteria>([
      ["supplier", new FrCriteria("Le fournisseur")]
    ]));
  }

  public addSupplierFilter(publisher: string) {
    this.addFilter("supplier", publisher);
  }

  public clearSupplier() {
    this.clearFilter("supplier");
  }

  public displaySupplierFilter(): string{
    return this.displayFilter("supplier");
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.supplierCriteria.onFilterAdded().pipe(tap(supplier => this.addSupplierFilter(supplier))).subscribe();

    this.route.queryParamMap.subscribe(queryParam => setTimeout(()=>this.searchWithQueryParam(queryParam)));
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<InvoiceSearchResult>> {
    var searchInvoiceRequest = {
      query: searchRequest.query,
      supplier: searchRequest.getValues("supplier"),
    };

    return this.invoiceService.search(searchInvoiceRequest, page, 20);
  }

  public openInvoice(invoice: InvoiceSearchResult) {
    this.router.navigateByUrl("/purchase/invoice/" + invoice.id);
  }

  public refresh() {
    this.router.navigate(["/purchase/invoice"], { queryParams: this.getQueryParams() });
  }

  public receive() {

  }

  public searchWithQueryParam(paramMap: ParamMap) {
    this.initWithParamMap(paramMap);

    this.search();
  }
}